module.exports = __webpack_public_path__ + "img/5.8c5fc0b6.png";